const VERTICAL_SPACING_SMART_LIST = 130;

const HORIZONTAL_SPACING_SMART_LIST = 70;

const AUTO_SAVE_INTERVAL = 15000;

export { VERTICAL_SPACING_SMART_LIST, HORIZONTAL_SPACING_SMART_LIST, AUTO_SAVE_INTERVAL };
